import * as React from "react"

export const ArrowDownSmall = () => (
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L6 5L11 1" stroke="currentColor" />
    </svg>
)
